import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { NavigationStart, Router } from '@angular/router';

interface Story {
  url: string;
  type: 'video' | 'image';
  duration?: number; // in seconds, for images
}

@Component({
  selector: 'app-story',
  templateUrl: './story.component.html',
  styleUrls: ['./story.component.css']
})
export class StoryComponent implements OnInit, OnDestroy {

  private navigationSubscription: any;

  @ViewChild('videoPlayer', { static: false }) videoPlayer: ElementRef<HTMLVideoElement>;

  @Input() stories: Story[] = [];
  @Input() initialIndex: number = 0;
  @Output() close = new EventEmitter<void>();

  currentStoryIndex: number = 0;
  progressInterval: any;
  progressWidth: string = '0%';
  startTime: number;

  constructor(
    
    private router: Router,      // Injecter le Router pour écouter les événements de navigation
    //private ownerId: string;
   
  ) { }

  ngOnInit(): void {
    this.currentStoryIndex = this.initialIndex;
    this.playCurrentStory();
    // Intercepter l'événement du bouton retour ou tout changement de navigation
    this.navigationSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        // Fermer la fenêtre modale si une navigation arrière est détectée
        this.closeStory();
      }
    });
  }

  ngOnDestroy(): void {
    this.stopVideo();

     // Nettoyer l'abonnement pour éviter les fuites de mémoire
     if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }

  get currentStory(): Story {
    return this.stories[this.currentStoryIndex];
  }

  /*loadUserProfile() {
    const userId = this.auth.getAuth().currentUser.uid; // Assurez-vous de récupérer l'ID utilisateur correctement
    this.firestore.getDocument({
      path: ["Users", userId],
      onComplete: result => {
        this.userData = result.data();

        // Logique pour récupérer les followers mutuels
        this.getMutualFollowers(this.auth.getAuth().currentUser.uid, this.userData.following).then(
          followers => {
          this.mutualFollowers = followers;
          }
        );

        if(this.userData?.profilePhotoUrl == ""){
          this.profilePhotoUrl = "https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/lenali.png?alt=media&token=ae3e0c00-4c03-492b-9a5a-444fd11c4e60";
        }else{
          this.profilePhotoUrl = this.userData?.profilePhotoUrl;
        }

        if(this.userData?.coverPhotoUrl == ""){
          this.coverPhotoUrl = "https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/defaultCoverImage.jpg?alt=media&token=d509e05d-dd94-4ff3-b37f-24430c3a82bf";
        }else{
          this.coverPhotoUrl = this.userData?.coverPhotoUrl;
        }
        
        
      },
      onFail: err => {
        console.error(err);
      }
    });


  }
 */
  playCurrentStory(): void {
    this.clearProgress();
    if (this.currentStory.type === 'video') {
      const video: HTMLVideoElement = this.videoPlayer.nativeElement;
      video.load();
      video.play();
    } else if (this.currentStory.type === 'image') {
      this.startProgress();
      setTimeout(() => this.nextStory(), this.currentStory.duration * 1000);
    }
  }

  startProgress(): void {
    this.clearProgress();
    this.startTime = Date.now();

    // Réinitialise la largeur de la barre de progression au début de chaque nouvelle story
    this.progressWidth = '0%';

    if (this.currentStory.type === 'video') {
        const video: HTMLVideoElement = this.videoPlayer.nativeElement;
        video.play();
    }

    this.progressInterval = setInterval(() => {
        const elapsedTime = (Date.now() - this.startTime) / 1000;
        if (this.currentStory.type === 'video') {
            const video: HTMLVideoElement = this.videoPlayer.nativeElement;
            this.progressWidth = `${(video.currentTime / video.duration) * 100}%`;
        } else if (this.currentStory.type === 'image') {
            // Calcule la progression basée sur la durée totale de la story
            this.progressWidth = `${(elapsedTime / this.currentStory.duration) * 100}%`;

            // Vérifie si la story a atteint sa durée pour passer à la suivante
            if (elapsedTime >= this.currentStory.duration) {
                this.nextStory();
            }
        }
    }, 100);
}


  updateProgress(): void {
    if (this.currentStory.type === 'video') {
      const video: HTMLVideoElement = this.videoPlayer.nativeElement;
      this.progressWidth = `${(video.currentTime / video.duration) * 100}%`;
    }
  }

  clearProgress(): void {
    clearInterval(this.progressInterval);
    this.progressWidth = '0%';
  }

  stopVideo(): void {
    if (this.videoPlayer && this.videoPlayer.nativeElement) {
      const video: HTMLVideoElement = this.videoPlayer.nativeElement;
      video.pause();
      video.currentTime = 0;
    }
  }


  nextStory(): void {
    this.clearProgress();
    this.currentStoryIndex = (this.currentStoryIndex + 1) % this.stories.length;
    this.playCurrentStory();
    this.startProgress(); // Ajoutez ceci pour démarrer le chronomètre pour la nouvelle story
  }


  prevStory(): void {
    this.clearProgress();
    this.currentStoryIndex = (this.currentStoryIndex - 1 + this.stories.length) % this.stories.length;
    this.playCurrentStory();
    this.startProgress(); 
  }

  closeStory(): void {
    this.stopVideo();
    this.clearProgress();
    this.close.emit();
  }

}
